import { z } from "zod";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { baseInviteSchema } from "@shared/schemas/sharedSchemas";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { useForm } from "@shared/features/form/useForm";

export type Args = {
  onSuccess: (data: any, variables: any) => void;
  programId: number;
};

export function useFriendInvitationForm({ onSuccess, programId }: Args) {
  const schema = baseInviteSchema;

  const fields = makeFormFields([
    "firstName",
    "lastName",
    "email",
    "confirmEmail",
  ]);

  const submitInvitation = useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return await apiRequest("/api/send-platform-invitation/", "POST", {
        email: data.email,
        first_name: data.firstName,
        last_name: data.lastName,
        program_id: programId,
      });
    },
    onError: (error: Error) => {
      throw error;
    },
    onSuccess: (data, variables) => {
      onSuccess(data, variables);
    },
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: submitInvitation.mutateAsync,
  });

  return { fields, form, handleSubmit, schema };
}

export default useFriendInvitationForm;
